import { ButtonSize, ButtonVariant, RegularButton } from "@/stories/button/button";

const SkeletonCalculator = () => {
    return (
        <div
            id="section-calculator"
            className="min-h-[261px] max-w-[421px] rounded-l14 border border-neutral-100 md:min-w-[421px]"
        >
            <div className="flex items-end justify-between border-b border-neutral-100 px-s9 py-s7 md:px-s9 md:py-4">
                <div id="block-price-info">
                    <p
                        id="buying-price-per-gram"
                        className="mb-1 mt-1 h-3 w-20 animate-pulse rounded-[23px] bg-neutral-100 text-sm font-regular leading-[160%] tracking-[0.14px]"
                    >
                        &nbsp;
                    </p>
                    <h2
                        id="buying-price-value"
                        className="mt-[11px] w-[150px] animate-pulse rounded-[23px] bg-neutral-100 text-xl font-semibold leading-[130%] tracking-[-0.24px] md:text-3xl"
                    >
                        &nbsp;
                    </h2>
                </div>
                <p
                    id="block-animation-live"
                    className="flex items-center text-xs leading-[140%] text-error-600"
                >
                    <span className="relative mr-1 flex size-2">
                        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-error-500 opacity-75"></span>
                        <span className="relative inline-flex size-2 rounded-full bg-error-600"></span>
                    </span>
                    LIVE
                </p>
            </div>

            <div id="block-onetime-sip" className="p-s7 pb-4 md:px-s9 md:pb-3 md:pt-6">
                <div className="flex h-[52px] animate-pulse gap-2 rounded-[12px] bg-neutral-100 p-1"></div>
            </div>

            <div className="flex flex-col items-center px-s7 py-s9 md:px-s9 md:pb-8 md:pt-5">
                <h5
                    id="title-onetime-investment"
                    className="mb-3 h-4 w-[60%] animate-pulse rounded-[20px] bg-neutral-100 text-center text-lg font-semibold leading-[130%]"
                >
                    &nbsp;
                </h5>
                <p
                    id="sub-title-amt-quantity"
                    className="h-2 w-[50%] animate-pulse rounded-[20px] bg-neutral-100 text-center text-sm font-regular leading-[160%] text-neutral-500 md:text-base"
                >
                    &nbsp;
                </p>
                <div className="w-full py-s9 mt-4">
                    <div
                        id="block-calc"
                        className={`border-neutral-100" } relative flex min-h-[50px] animate-pulse items-center rounded-[12px] border bg-neutral-100 md:mb-4 md:rounded-xl`}
                    ></div>

                    <p
                        id="info-container"
                        className="mt-s7 flex h-5 items-center gap-2 text-left text-sm leading-[160%] text-neutral-500 md:mt-0 md:text-base"
                    ></p>
                </div>
                <div
                    id="block-total-gained"
                    className="mb-2 flex w-full items-center justify-between"
                >
                    <p
                        id="name"
                        className="h-4 w-[35%] animate-pulse rounded-[20px] bg-neutral-100 text-sm font-semibold leading-[160%] md:text-base"
                    >
                        &nbsp;
                    </p>
                    <p
                        id="value"
                        className="h-4 w-[20%] animate-pulse rounded-[20px] bg-neutral-100 text-sm font-semibold leading-[160%] md:text-base"
                    >
                        &nbsp;
                    </p>
                </div>
            </div>

            <div className="hidden px-s9 pb-s9 md:block">
                <RegularButton
                    label="&nbsp;"
                    variant={ButtonVariant.PrimaryDefault}
                    size={ButtonSize.Large}
                    noIcon={true}
                    showRightIcon={false}
                    className="min-w-full animate-pulse"
                    disabled={true}
                />
            </div>
        </div>
    );
};

export default SkeletonCalculator;
